import Vue from 'vue';

Vue.component('fuel-index', () =>
    import(/* webpackChunkName: 'fuel-index' */ './fuel-index.vue'),
);

Vue.component('fuel-create', () =>
    import(/* webpackChunkName: 'fuel-create' */ './fuel-create.vue'),
);

Vue.component('fuel-datatable', () =>
    import(/* webpackChunkName: 'fuel-datatable' */ './fuel-datatable.vue'),
);

Vue.component('dipping-index', () =>
    import(/* webpackChunkName: 'dipping-index' */ './dipping/dipping-index.vue'),
);

Vue.component('receiving-index', () =>
    import(/* webpackChunkName: 'receiving-index' */ './receiving/receiving-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/fuel/index.js